import Vue from 'vue'
import Vuex from 'vuex'
import md5 from 'crypto-js/md5'

// Import modules
// Managing Async State
import asyncModule from './modules/asyncDone'
// Managing Alert
import alertModule from './modules/alert'
// managing sidebar mini
import sidebarMiniModule from './modules/sidebarMini'
// Managing Cutomer's Basic Data
import customerModule from './modules/customer'
// Managing Costomer's Hosting Data
import hostingAccountsModule from './modules/hostingAccounts'
// Managing Customer's support tickets list
import supportTicketsListModule from './modules/supportTickets.js'
// Managing Migration Details
import migrationModule from './modules/migration';
import tasks from './modules/tasks';
// Managing the secret pass phreases for AES encryption
import cryptoModule from './modules/crypto'
import notification from './modules/notification'

import planModule from './modules/plan'
import dnsModule from './modules/dns'
import monitor from "@/store/modules/monitor";

Vue.use(Vuex)

export default new Vuex.Store({
	state: {
		ticketBusyFactor: 0,
		user: {
			uid: null,
			firstName: null,
			lastName: null,
			email: null,
			customerID: null,
			userType: null,
			idToken: null,
			collaborators: [],
			notifications: false,
			muteNoti:false,
			diskAlertNotification: false,
			diskAlertSound: false,
			stopStatusCake: false,
			hbName : null,
			isHR: false,
			getNotificationStatus: false,
			fcmToken: [],
			isOnBreakOrSignedOut: false,
			hostBillId: null,
		},
        admin: { //to maintain admin data, if admin goes to user side.
            uid: null,
            firstName: null,
            lastName: null,
            email: null,
            customerID: null,
            userType: null,
            idToken: null,
			notifications: false,
			getNotificationStatus: false,
        },
		isVisibleModal: false,
		requestUserId: null,
		requestCustomerID: null,
		showNotificationOnLoggedIn: true,
		upNotiOnLogin: true,
		downNotiOnLogin: true,
		stagingRequested: false,
		pushToLiveRequested: false,
		backupState: {
			actionValue: '',
			actionType: false,
			disableInput: false
		},
		backendJobLoading: false,
		requestFreshWPInstall:{
			domain: '',
			plan: ''
		},
		rememberComputer:true,
		emailSetup:false,
		freshWordPressDisable:false,
		fixPhpMyAdminLoader: false,
		fixPermissionsLoader: false,
		showSingleAnnouncement: false,
	},
	getters: {
		isOnBreakOrSignout(state) {
			return state.user.isOnBreakOrSignedOut
		},
		getBusyFactor: (state) => {
			return state.ticketBusyFactor;
		},
		getShowSingleAnnouncement(state) {
			return state.showSingleAnnouncement
		},
		getStatusCakeStatus (state) {
			return state.user.stopStatusCake;
		},
		getFixPhpMyAdminLoader(state) {
			return state.fixPhpMyAdminLoader;
		},
		getFixPermissionsLoader(state) {
			return state.fixPermissionsLoader;
		},
		getRememberCoumputer(state) {
			return state.rememberComputer;
		},
		getRequestFreshWPInstall(state) {
			return state.requestFreshWPInstall;
		},
		backendJobLoading(state){
			return state.backendJobLoading;
		},
		actionType(state){
			return state.backupState.actionType;
		},
		actionValue(state){
			return state.backupState.actionValue;
		},
		disableInput(state){
			return state.backupState.disableInput;
		},
		stagingRequested(state){
			return state.stagingRequested;
		},
		pushToLiveRequested(state){
			return state.pushToLiveRequested;
		},
		isShowNotificationOnLoggedIn(state) {
			return state.showNotificationOnLoggedIn;
		},
		requestUserId(state) {
			return state.requestUserId
		},
		user(state) {
			return state.user
		},
        admin (state) {
            return state.admin
        },
		userFullName(state) {
			return `${state.user.firstName} ${state.user.lastName}`
		},
		userEmail(state) {
			if (state.user.email === null) {
				return null
			} else {
				return state.user.email.trim().toLowerCase()
			}
		},
		emailHashGravatar(state) {
			if (state.user.email === null) {
				return null
			} else {
				return md5(state.user.email.trim().toLowerCase()).toString()
			}
		},
		getUID(state) {
			return state.user.uid
		},
		getCustomerID(state) {
			return state.user.customerID
		},
		getRequestCustomerID(state) {
			return state.requestCustomerID
		},
		getUserType(state) {
			return state.user.userType
		},
		getUserToken(state) {
			return state.user.idToken
		},
		isVisibleModal(state) {
			return state.isVisibleModal
		},
		isNotifications(state){
			return state.user.notifications;
		},
		muteNotiFlag(state){
			return state.user.muteNoti;
		},
		diskAlertNotification(state){
			return state.user.diskAlertNotification;
		},
		diskAlertSound(state){
			return state.user.diskAlertSound;
		},
		isUpNoti(state){
			return state.upNotiOnLogin;
		},
		isDownNoti(state){
			return state.downNotiOnLogin;
		}
	},
	mutations: {
		mutateStatusCakeStatus (state, payload) {
			let userDtls = JSON.parse(localStorage.getItem('userDtls'));
			userDtls.stopStatusCake = payload;
			state.user.stopStatusCake = payload;
			localStorage.setItem('userDtls', JSON.stringify(state.user));
		},
		mutateSingleAnnouncement(state, payload){
		 	state.showSingleAnnouncement = payload;
		},
		mutateUserType (state , payload) {
			state.user.userType = payload.userType;
			let userDtls = JSON.parse(localStorage.getItem('userDtls'));
			userDtls.userType = state.userType ;
			localStorage.setItem('userDtls', JSON.stringify(state.user));
		},
		mutateFixPhpMyAdminLoader(state, payload) {
			state.fixPhpMyAdminLoader = payload;
		},
		mutateSelectedPlansForMonitorAlerts(state, payload) {
			let userDtls = JSON.parse(localStorage.getItem('userDtls'));
			userDtls.selectedPlansForMonitorAlert = payload;
			state.user.selectedPlansForMonitorAlert = payload;
			localStorage.setItem('userDtls', JSON.stringify(state.user));
		},
		mutateFixPermissionsLoader(state, payload) {
			state.fixPermissionsLoader = payload;
		},
		mutateRememberComputer(state, payload){
			state.rememberComputer = payload;
		},
		mutateRequestFreshWPInstall(state, payload){
			state.requestFreshWPInstall.domain = payload.domain;
			state.requestFreshWPInstall.plan = payload.plan;
		},
		updateAdminNotificationOnLogin(state, payload) {
			if(payload.type === 'Up'){
				state.upNotiOnLogin = payload.status
			}else{
				state.downNotiOnLogin = payload.status;
			}
		},
		updateBackendJobLoading(state, payload) {
			state.backendJobLoading = payload;
		},
		updateBackupActions(state, payload){
			state.backupState.actionValue = payload.value;
			state.backupState.actionType = payload.type;
			state.backupState.disableInput = payload.input;
		},
		updateFreshWordPressDisable(state, payload){
			state.freshWordPressDisable = payload;
		},
		updateStagingRequested(state, payload){
			state.stagingRequested = payload;
		},
		updatePushToLiveRequested(state, payload){
			state.pushToLiveRequested = payload;
		},
		updateShowNotificationOnLogIn(state, payload){
			state.showNotificationOnLoggedIn = payload;
		},
		updateRequestCustomerID(state, payload){
			state.requestCustomerID = payload
		},
		updateRequestUserId(state, payload){
			state.requestUserId = payload
		},
		updatePushNotificationStatus(state, payload){
			console.log('payload from store', payload)
			state.admin.getNotificationStatus= payload
			state.user.getNotificationStatus= payload
			localStorage.setItem('userDtls', JSON.stringify(state.user));
		},
		updateUser(state, payload) {
			console.log('update user payload', payload)
			state.user.uid = payload.uid
			state.user.firstName = payload.firstName
			state.user.lastName = payload.lastName
			state.user.signature = payload.signature
			state.user.email = payload.email
			state.user.customerID = payload.customerID
			state.user.userType = payload.userType
			state.user.idToken = payload.idToken
			state.user.collaborators = payload.collaborators
			if(state.user.userType !== 'normal'){
				state.user.notifications = (payload.notifications === undefined) ? false : payload.notifications;
				state.user.muteNoti = payload.muteNoti;
				state.user.selectedPlansForMonitorAlert = payload.selectedPlansForMonitorAlert || ['Starter', 'Professional', 'VPS', 'Business', 'Enterprise', 'Dedicated', 'Managed WordPress', 'Journey', 'Mediavine Plan 1', 'Mediavine Plan 2', 'Mediavine Plan 3', 'Mediavine Enterprise', 'North Commerce Starter'];
				state.user.diskAlertSound = (payload.diskAlertSound === undefined) ? false : payload.diskAlertSound;
				state.user.diskAlertNotification = payload.diskAlertNotification;
			}
			state.user.fcmToken = payload.fcmToken
			state.emailSetup = (payload.isEmailSetup === undefined) ? false : payload.isEmailSetup;
			state.user.stopStatusCake = (payload.stopStatusCake === undefined) ? false : payload.stopStatusCake;
			state.user.hbName = payload.hbName;
			state.user.isHR = payload.isHR;
			state.user.getNotificationStatus= (payload.getNotificationStatus ===undefined) ? false : payload.getNotificationStatus
			state.user.hostBillId = payload.hostBillId === undefined ? null : payload.hostBillId;
		},
        updateAdmin (state, payload) {
            state.admin.uid = payload.uid
            state.admin.firstName = payload.firstName
            state.admin.lastName = payload.lastName
            state.admin.email = payload.email
            state.admin.customerID = payload.customerID
            state.admin.userType = payload.userType
            state.admin.idToken = payload.idToken
			state.admin.notifications = payload.notifications;
			state.admin.isHR = payload.isHR;
			state.admin.getNotificationStatus= (payload.getNotificationStatus ===undefined) ? false : payload.getNotificationStatus
        },
		nameMutate(state, payload) {
			state.user.firstName = payload.firstName
			state.user.lastName = payload.lastName
		},
		signatureMutate(state, payload) {
			state.user.signature = payload.signature
		},
		hbNameMutate(state, payload){
			state.user.hbName= payload.hbName;
		},
		emailMutate(state, payload) {
			state.user.email = payload.email
		},
        tokenMutate(state, payload) {
            state.user.idToken = payload;
            if(localStorage.getItem('adminDtls')){
                state.admin.idToken = payload
                localStorage.setItem('adminDtls', JSON.stringify(state.admin));
            }
            localStorage.setItem('userDtls', JSON.stringify(state.user));
        },
		modalMutate(state, payload) {
			state.isVisibleModal = payload
		},
		notificationMutate(state, payload){
			let userDtls = JSON.parse(localStorage.getItem('userDtls'));
			userDtls.notifications = payload;
			state.user.notifications = payload;
			localStorage.setItem('userDtls', JSON.stringify(state.user));
		},diskAlertNotificationMutate(state, payload){
			let userDtls = JSON.parse(localStorage.getItem('userDtls'));
			userDtls.diskAlertNotification = payload;
			state.user.diskAlertNotification = payload;
			localStorage.setItem('userDtls', JSON.stringify(state.user));
		},diskAlertSoundMutate(state, payload){
			let userDtls = JSON.parse(localStorage.getItem('userDtls'));
			userDtls.diskAlertSound = payload;
			state.user.diskAlertSound = payload;
			localStorage.setItem('userDtls', JSON.stringify(state.user));
		},
		muteNotiMutate(state, payload){
			let userDtls = JSON.parse(localStorage.getItem('userDtls'));
			userDtls.muteNoti = payload;
			state.user.muteNoti = payload;
			localStorage.setItem('userDtls', JSON.stringify(state.user));
		},
		updateSignedInOrOnBreakStatus(state, payload){
			state.user.isOnBreakOrSignedOut = payload
		},
		calculateBusyFactorMutation(state, payload) {
			let availableCount = payload.availableCount
			if(!payload.availableCount || payload.availableCount == 0) {
				availableCount = 1
			}
			state.ticketBusyFactor = Number(((payload.total_tickets_handled+payload.total_responses)/Number(availableCount)).toFixed(2))
		}
	},
	actions: {
		calculateBusyCoefficient(context, payload){
			context.commit('calculateBusyFactorMutation', payload);
		},
		setSignedInOrOnBreakStatus(context, payload){
			context.commit('updateSignedInOrOnBreakStatus', payload)
		},
		setPushNotificationStatus(context, payload){
			context.commit('updatePushNotificationStatus', payload)
		},
		setRememberComputer(context, payload) {
			context.commit('mutateRememberComputer', payload)
		},
		setRequestCustomerID(context, payload) {
			context.commit('updateRequestCustomerID', payload)
		},
		setRequestUserId(context, payload) {
			context.commit('updateRequestUserId', payload)
		},
		updateUserDetails(context, payload) {
			context.commit('updateUser', payload)
		},
        updateAdminDetails(context, payload) {
            context.commit('updateAdmin', payload)
        },
		updateName(context, payload) {
			context.commit('nameMutate', payload)
		},
		updateSignature(context, payload) {
			context.commit('signatureMutate', payload)
		},
		updateHbName(context, payload) {
			context.commit('hbNameMutate', payload)
		},
		updateEmail(context, payload) {
			context.commit('emailMutate', payload)
		},
        updateToken(context, payload) {
            context.commit('tokenMutate', payload);
        },
		updateModalVisible(context, payload) {
			console.log(payload);
			context.commit('modalMutate', payload)
		},
		updateNotifications(context, payload){
			context.commit('notificationMutate', payload)
		}

	},
	modules: {
		crypto: cryptoModule,
		async: asyncModule,
		alert: alertModule,
		sidebarMini: sidebarMiniModule,
		customer: customerModule,
		hosting: hostingAccountsModule,
		tickets: supportTicketsListModule,
		migration: migrationModule,
		plan: planModule,
		dns: dnsModule,
		notification: notification,
		tasks: tasks,
		monitor: monitor,
	}
})
